import { createApiQuery } from '@/hooks/use-api-query';
import { get } from '@/libs/http';
import { useQuery } from '@tanstack/react-query';
import { BalanceListRes } from '@/types/api/deposit-payment/balance-list.d';
import { QueryConfig } from '@/types/react-query';

export const getBalanceList = (isPolling?: boolean) =>
  get<BalanceListRes>('/wallet/v1/balance_list', {
    isPollingRequest: !!isPolling,
  } as any);

const { getQueryOptions } = createApiQuery(
  () => getBalanceList(false), // 默认非轮询
  () => ['balance-list']
);

// 重写 useQueryHook 以支持轮询标记
export const useGetBalanceList = (options: {
  params?: Record<string, never>;
  queryConfig?: QueryConfig<() => ReturnType<typeof getQueryOptions>>;
}) => {
  const { queryConfig } = options;
  const isPolling = !!queryConfig?.refetchInterval;

  // 重写 queryFn 以传递轮询标记
  const customQueryOptions = {
    ...getQueryOptions({}),
    queryFn: () => getBalanceList(isPolling),
    ...queryConfig,
  };

  return useQuery(customQueryOptions);
};
